export default "__VITE_ASSET__e31a52ce__"